const registroInitialState = {
  registro: {
    loading: false,
    error: false,
    data: null,
    usuario: {
      nro_documento: "",
      nombre: "",
      apellido: "",
      fecha_nacimiento: "",
      email: "",
      idlocalidad: "",
      domicilio: "",
      telefono: "",
      telefono_movil: "",
      obra_social: "",
      plan_obra_social: "",
      nro_afiliado: "",
      tipo_iva: 0,
      solicitaRedSoc: false,
    },
    listError: {
      nro_documento: false,
      nombre: false,
      password: false,
      apellido: false,
      fecha_nacimiento: false,
      email: false,
      idlocalidad: false,
      domicilio: false,
      telefono: false,
      telefono_movil: false,
      obra_social: false,
      plan_obra_social: false,
      tipo_iva: false,
      nro_afiliado: false,
    },
  },
};

export default registroInitialState;
